import { GETNONPROJECTMEMBER_SUCCESS, GETNONPROJECTMEMBER_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const getNonProjectMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETNONPROJECTMEMBER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETNONPROJECTMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getNonProjectMemberReducer;
